import { render, staticRenderFns } from "./childbirth.vue?vue&type=template&id=d698cb84&scoped=true"
import script from "./childbirth.vue?vue&type=script&lang=js"
export * from "./childbirth.vue?vue&type=script&lang=js"
import style0 from "./childbirth.vue?vue&type=style&index=0&id=d698cb84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d698cb84",
  null
  
)

export default component.exports